import { render, staticRenderFns } from "./SideworkSettings.vue?vue&type=template&id=e99de200&scoped=true&"
import script from "./SideworkSettings.vue?vue&type=script&lang=js&"
export * from "./SideworkSettings.vue?vue&type=script&lang=js&"
import style0 from "./SideworkSettings.vue?vue&type=style&index=0&id=e99de200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99de200",
  null
  
)

export default component.exports